export const classes = {
  section: 'p-6',
};
